// Fixes AAWZ-WEB-17H: filter non-actionable "Non-Error promise rejection" events
// that have no stack trace and provide zero diagnostic value.
export function isNonErrorPrimitiveRejection(event) {
  const values = event.exception && event.exception.values
  if (!values || values.length !== 1) return false
  const exc = values[0]
  return (
    exc.type === 'UnhandledRejection' &&
    typeof exc.value === 'string' &&
    exc.value.startsWith('Non-Error promise rejection captured with value:') &&
    (!exc.stacktrace || !exc.stacktrace.frames || exc.stacktrace.frames.length === 0)
  )
}

// Fixes AAWZ-WEB-17H: convert primitive unhandled rejections (string, undefined,
// null, number, boolean) into proper Error instances so they carry a stack trace.
// Must be registered BEFORE Sentry.init() to intercept first.
export function setupGlobalRejectionHandler() {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason
    if (reason instanceof Error) return
    if (reason !== null && reason !== undefined && typeof reason === 'object') return

    event.preventDefault()

    const label =
      reason === '' || reason === undefined || reason === null
        ? '(empty)'
        : String(reason)
    const wrapped = new Error(`Unhandled promise rejection: ${label}`)
    wrapped.originalReason = reason

    console.warn('[GlobalRejectionHandler]', wrapped.message)
  })
}
